// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/readex-pro/ReadexPro-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/readex-pro/ReadexPro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/readex-pro/ReadexPro-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/readex-pro/ReadexPro-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

body {
  line-height: 1;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after,
q:before, q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

:root {
  --color-primary: 237 187 38;
  --bg-primary: 14 14 14;
  --text-primary: 255 255 255;
  --text-secondary: 173 173, 173;
}

.leaflet-popup-tip {
  display: none;
}

.popup-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.popup-container a {
  text-decoration: none;
  color: rgb(var(--color-primary));
  font-size: 20px;
}
.popup-container div {
  border-radius: 10px;
}

.leaflet-popup-content {
  width: auto !important;
}

.main {
  display: flex;
}
.main .sidebar {
  width: 18vw;
  height: 100vh;
  background: rgb(var(--bg-primary));
}
.main .sidebar .header {
  width: 100%;
  height: 80px;
  display: grid;
  place-items: center;
}
.main .sidebar .header .logo {
  align-items: center;
  display: flex;
  gap: 10px;
  font-size: 28px;
  font-weight: bold;
}
.main .sidebar .locations {
  padding: 20px;
  height: calc(100% - 140px);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}
.main .sidebar .locations::-webkit-scrollbar {
  background: rgb(var(--bg-primary));
  width: 8px;
}
.main .sidebar .locations::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  background-clip: padding-box;
  background-color: rgb(var(--text-primary)/0.2);
}
.main .sidebar .locations .search-box {
  font-size: 14px;
  background: rgb(var(--text-primary)/0.05);
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  position: relative;
  height: 46px;
  position: sticky;
  top: -20px;
  -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
}
.main .sidebar .locations .search-box input {
  height: 100%;
  appearance: none;
  box-shadow: none;
  outline: none;
  background: transparent;
  border: none;
  color: inherit;
  font-size: 14px;
  font-family: inherit;
  width: 100%;
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  padding-left: 18px;
  padding-right: 48px;
  box-sizing: border-box;
}
.main .sidebar .locations .search-box svg {
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%);
}
.main .sidebar .locations .location {
  font-size: 14px;
  padding: 0px 18px;
  height: 46px;
  background: rgb(var(--text-primary)/0.02);
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
  -webkit-user-select: none;
          user-select: none;
}
.main .sidebar .locations .location .badge {
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 50px;
  background: rgb(var(--color-primary));
  color: rgb(var(--bg-primary));
  box-shadow: 0 6px 10px rgb(var(--color-primary)/0.5);
  transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.main .sidebar .locations .location:not(:last-child) {
  margin-bottom: 14px;
}
.main .sidebar .locations .location.active {
  background: rgb(var(--color-primary));
  color: rgb(var(--bg-primary));
}
.main .sidebar .locations .location.active .badge {
  box-shadow: none;
  background: rgb(var(--text-primary));
}
.main .sidebar .locations .location.sub {
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  position: relative;
}
.main .sidebar .locations .location.sub .content {
  width: 100%;
  margin-top: 20px;
}
.main .sidebar .locations .location.sub .badge {
  position: absolute;
  top: 14px;
  right: 18px;
}
.main .sidebar .locations .location.sub.active {
  background: rgb(var(--text-primary)/0.05);
  color: rgb(var(--text-primary));
  height: auto;
  padding: 18px 18px;
  border-radius: 20px;
}
.main .sidebar .locations .location.sub.active .badge {
  top: 18px;
}
.main .sidebar .text {
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 6px;
  display: flex;
  color: rgb(var(--text-primary)/0.5);
  height: 60px;
}

.leaflet-popup-content-wrapper {
  background: rgb(var(--bg-primary));
}

.location-card {
  position: absolute;
  width: 420px;
  left: 50%;
  bottom: 110%;
  transform: translateX(-50%);
  aspect-ratio: 16/9;
  border-radius: 0.9svw;
  overflow: hidden;
  box-shadow: 0 0 30px rgb(var(--bg-primary)) !important;
  transform-origin: bottom center;
  animation: fadeIn 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.location-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.location-card__footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 35%;
  padding-inline: 6%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border-top: 1px solid rgb(var(--text-primary)/0.2);
  background: rgb(var(--bg-primary)) !important;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
}
.location-card__name {
  font-size: 16px;
}
.location-card__spawn {
  align-items: center;
  display: flex;
  gap: 4px;
  border-radius: 50px;
  background: rgb(var(--text-primary)/0.1) !important;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  font-size: 14px;
  padding: 2% 6%;
  cursor: pointer;
  transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.location-card__spawn svg {
  width: 1.5vmin;
  height: 1.5vmin;
}
.location-card__spawn:hover {
  background: rgb(var(--color-primary));
  color: rgb(var(--bg-primary));
}

@font-face {
  font-family: "ReadexPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 300;
}
@font-face {
  font-family: "ReadexPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: normal;
}
@font-face {
  font-family: "ReadexPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 500;
}
@font-face {
  font-family: "ReadexPro";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: bold;
}
body {
  font-family: "ReadexPro";
  color: rgb(var(--text-primary));
}`, "",{"version":3,"sources":["webpack://./src/styles/cssreset.scss","webpack://./src/styles/global.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/main.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;EAaE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;ACCF;;ADCA,gDAAA;AACA;;EAEE,cAAA;ACEF;;ADAA;EACE,cAAA;ACGF;;ADDA;EACE,gBAAA;ACIF;;ADFA;EACE,YAAA;ACKF;;ADHA;;EAEE,WAAA;EACA,aAAA;ACMF;;ADJA;EACE,yBAAA;EACA,iBAAA;ACOF;;AChDA;EACE,2BAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;ADmDF;;AEvDA;EACE,aAAA;AF0DF;;AEhDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AFmDF;AEjDE;EACE,qBAAA;EACA,gCAAA;EACA,eAAA;AFmDJ;AEhDE;EACE,mBAAA;AFkDJ;;AE9CA;EACE,sBAAA;AFiDF;;AE7CA;EACE,aAAA;AFgDF;AE9CE;EACE,WAAA;EACA,aAAA;EACA,kCAAA;AFgDJ;AE/CI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AFiDN;AEhDM;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AFkDR;AE/CI;EACE,aAAA;EACA,0BAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AFiDN;AE/CM;EACE,kCAAA;EACA,UAAA;AFiDR;AE9CM;EACE,6BAAA;EACA,4BAAA;EACA,8CAAA;AFgDR;AE9CM;EACE,eAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,mCAAA;UAAA,2BAAA;AFgDR;AE/CQ;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AFiDV;AE/CQ;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AFiDV;AE9CM;EACE,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,oDAAA;EACA,yBAAA;UAAA,iBAAA;AFgDR;AE/CQ;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,6BAAA;EACA,oDAAA;EACA,oDAAA;AFiDV;AE/CQ;EACE,mBAAA;AFiDV;AE/CQ;EACE,qCAAA;EACA,6BAAA;AFiDV;AEhDU;EACE,gBAAA;EACA,oCAAA;AFkDZ;AE/CQ;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AFiDV;AEhDU;EACE,WAAA;EACA,gBAAA;AFkDZ;AEhDU;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AFkDZ;AEhDU;EACE,yCAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AFkDZ;AEjDY;EACE,SAAA;AFmDd;AE7CI;EACE,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,mCAAA;EACA,YAAA;AF+CN;;AE1CA;EACE,kCAAA;AF6CF;;AEzCE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sDAAA;EACA,+BAAA;EACA,0DAAA;AF4CJ;AE3CI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AF6CN;AE3CI;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kDAAA;EACA,6CAAA;EACA,kCAAA;UAAA,0BAAA;AF6CN;AE3CI;EACE,eAAA;AF6CN;AE3CI;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mDAAA;EACA,kCAAA;UAAA,0BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,oDAAA;AF6CN;AE5CM;EACE,cAAA;EACA,eAAA;AF8CR;AE5CM;EACE,qCAAA;EACA,6BAAA;AF8CR;;AAxRA;EACE,wBAAA;EACA,4CAAA;EACA,gBAAA;AA2RF;AAzRA;EACE,wBAAA;EACA,4CAAA;EACA,mBAAA;AA2RF;AAzRA;EACE,wBAAA;EACA,4CAAA;EACA,gBAAA;AA2RF;AAxRA;EACE,wBAAA;EACA,4CAAA;EACA,iBAAA;AA0RF;AAvRA;EACE,wBAAA;EACA,+BAAA;AAyRF","sourcesContent":["html, body, div, span, applet, object, iframe,\r\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\r\na, abbr, acronym, address, big, cite, code,\r\ndel, dfn, em, img, ins, kbd, q, s, samp,\r\nsmall, strike, strong, sub, sup, tt, var,\r\nb, u, i, center,\r\ndl, dt, dd, ol, ul, li,\r\nfieldset, form, label, legend,\r\ntable, caption, tbody, tfoot, thead, tr, th, td,\r\narticle, aside, canvas, details, embed,\r\nfigure, figcaption, footer, header, hgroup,\r\nmenu, nav, output, ruby, section, summary,\r\ntime, mark, audio, video {\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 0;\r\n  font-size: 100%;\r\n  font: inherit;\r\n  vertical-align: baseline;\r\n}\r\n/* HTML5 display-role reset for older browsers */\r\narticle, aside, details, figcaption, figure,\r\nfooter, header, hgroup, menu, nav, section {\r\n  display: block;\r\n}\r\nbody {\r\n  line-height: 1;\r\n}\r\nol, ul {\r\n  list-style: none;\r\n}\r\nblockquote, q {\r\n  quotes: none;\r\n}\r\nblockquote:before, blockquote:after,\r\nq:before, q:after {\r\n  content: '';\r\n  content: none;\r\n}\r\ntable {\r\n  border-collapse: collapse;\r\n  border-spacing: 0;\r\n}","@use \"cssreset\";\r\n@use \"variables\";\r\n@use \"main\";\r\n\r\n@font-face {\r\n  font-family: \"ReadexPro\";\r\n  src: url(\"../../public/fonts/readex-pro/ReadexPro-Light.ttf\");\r\n  font-weight: 300;\r\n}\r\n@font-face {\r\n  font-family: \"ReadexPro\";\r\n  src: url(\"../../public/fonts/readex-pro/ReadexPro-Regular.ttf\");\r\n  font-weight: normal;\r\n}\r\n@font-face {\r\n  font-family: \"ReadexPro\";\r\n  src: url(\"../../public/fonts/readex-pro/ReadexPro-Medium.ttf\");\r\n  font-weight: 500;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"ReadexPro\";\r\n  src: url(\"../../public/fonts/readex-pro/ReadexPro-Bold.ttf\");\r\n  font-weight: bold;\r\n}\r\n\r\nbody {\r\n  font-family: \"ReadexPro\";\r\n  color: rgb(var(--text-primary));\r\n}\r\n",":root {\r\n  --color-primary: 237 187 38;\r\n  --bg-primary: 14 14 14;\r\n  --text-primary: 255 255 255;\r\n  --text-secondary: 173 173, 173;\r\n}\r\n",".leaflet-popup-tip {\r\n  display: none;\r\n}\r\n\r\n//.leaflet-popup {\r\n//  height: 1vh;\r\n//  width: 40vw;\r\n//  left: -25vw !important;\r\n//  bottom: 20vh !important;\r\n//}\r\n//\r\n.popup-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n\r\n  a {\r\n    text-decoration: none;\r\n    color: rgb(var(--color-primary));\r\n    font-size: 20px;\r\n  }\r\n\r\n  div {\r\n    border-radius: 10px;\r\n  }\r\n}\r\n\r\n.leaflet-popup-content {\r\n  width: auto !important;\r\n}\r\n\r\n\r\n.main {\r\n  display: flex;\r\n\r\n  .sidebar {\r\n    width: 18vw;\r\n    height: 100vh;\r\n    background: rgb(var(--bg-primary));\r\n    .header {\r\n      width: 100%;\r\n      height: 80px;\r\n      display: grid;\r\n      place-items: center;\r\n      .logo {\r\n        align-items: center;\r\n        display: flex;\r\n        gap: 10px;\r\n        font-size: 28px;\r\n        font-weight: bold;\r\n      }\r\n    }\r\n    .locations {\r\n      padding: 20px;\r\n      height: calc(100% - 140px);\r\n      box-sizing: border-box;\r\n      overflow-y: auto;\r\n      overflow-x: hidden;\r\n\r\n      &::-webkit-scrollbar {\r\n        background: rgb(var(--bg-primary));\r\n        width: 8px;\r\n      }\r\n\r\n      &::-webkit-scrollbar-thumb {\r\n        border: 2px solid transparent;\r\n        background-clip: padding-box;\r\n        background-color: rgb(var(--text-primary) / 0.2);\r\n      }\r\n      .search-box {\r\n        font-size: 14px;\r\n        background: rgb(var(--text-primary) / 0.05);\r\n        border-radius: 50px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        margin-bottom: 14px;\r\n        position: relative;\r\n        height: 46px;\r\n        position: sticky;\r\n        top: -20px;\r\n        backdrop-filter: blur(20px);\r\n        input {\r\n          height: 100%;\r\n          appearance: none;\r\n          box-shadow: none;\r\n          outline: none;\r\n          background: transparent;\r\n          border: none;\r\n          color: inherit;\r\n          font-size: 14px;\r\n          font-family: inherit;\r\n          width: 100%;\r\n          position: absolute;\r\n          height: 100%;\r\n          left: 0;\r\n          top: 0;\r\n          padding-left: 18px;\r\n          padding-right: 48px;\r\n          box-sizing: border-box;\r\n        }\r\n        svg {\r\n          position: absolute;\r\n          top: 50%;\r\n          right: 18px;\r\n          transform: translateY(-50%);\r\n        }\r\n      }\r\n      .location {\r\n        font-size: 14px;\r\n        padding: 0px 18px;\r\n        height: 46px;\r\n        background: rgb(var(--text-primary) / 0.02);\r\n        border-radius: 50px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        cursor: pointer;\r\n        transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);\r\n        user-select: none;\r\n        .badge {\r\n          font-size: 12px;\r\n          font-weight: bold;\r\n          text-transform: uppercase;\r\n          padding: 2px 6px;\r\n          border-radius: 50px;\r\n          background: rgb(var(--color-primary));\r\n          color: rgb(var(--bg-primary));\r\n          box-shadow: 0 6px 10px rgb(var(--color-primary) / 0.5);\r\n          transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);\r\n        }\r\n        &:not(:last-child) {\r\n          margin-bottom: 14px;\r\n        }\r\n        &.active {\r\n          background: rgb(var(--color-primary));\r\n          color: rgb(var(--bg-primary));\r\n          .badge {\r\n            box-shadow: none;\r\n            background: rgb(var(--text-primary));\r\n          }\r\n        }\r\n        &.sub {\r\n          align-items: flex-start;\r\n          justify-content: center;\r\n          flex-direction: column;\r\n          position: relative;\r\n          .content {\r\n            width: 100%;\r\n            margin-top: 20px;\r\n          }\r\n          .badge {\r\n            position: absolute;\r\n            top: 14px;\r\n            right: 18px;\r\n          }\r\n          &.active {\r\n            background: rgb(var(--text-primary) / 0.05);\r\n            color: rgb(var(--text-primary));\r\n            height: auto;\r\n            padding: 18px 18px;\r\n            border-radius: 20px;\r\n            .badge {\r\n              top: 18px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n    .text {\r\n      align-items: center;\r\n      width: 100%;\r\n      justify-content: center;\r\n      gap: 6px;\r\n      display: flex;\r\n      color: rgb(var(--text-primary) / 0.5);\r\n      height: 60px;\r\n    }\r\n  }\r\n}\r\n\r\n.leaflet-popup-content-wrapper {\r\n  background: rgb(var(--bg-primary));\r\n}\r\n\r\n\r\n  .location-card {\r\n    position: absolute;\r\n    width: 420px;\r\n    left: 50%;\r\n    bottom: 110%;\r\n    transform: translateX(-50%);\r\n    aspect-ratio: 16/9;\r\n    border-radius: 0.9svw;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 30px rgb(var(--bg-primary)) !important;\r\n    transform-origin: bottom center;\r\n    animation: fadeIn 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);\r\n    img {\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: cover;\r\n    }\r\n    &__footer {\r\n      position: absolute;\r\n      left: 0;\r\n      bottom: 0;\r\n      width: 100%;\r\n      height: 35%;\r\n      padding-inline: 6%;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      box-sizing: border-box;\r\n      border-top: 1px solid rgb(var(--text-primary) / 0.2);\r\n      background: rgb(var(--bg-primary)) !important;\r\n      backdrop-filter: blur(8px);\r\n    }\r\n    &__name {\r\n      font-size: 16px;\r\n    }\r\n    &__spawn {\r\n      align-items: center;\r\n      display: flex;\r\n      gap: 4px;\r\n      border-radius: 50px;\r\n      background: rgb(var(--text-primary) / 0.1) !important;\r\n      backdrop-filter: blur(4px);\r\n      font-size: 14px;\r\n      padding: 2% 6%;\r\n      cursor: pointer;\r\n      transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);\r\n      svg {\r\n        width: 1.5vmin;\r\n        height: 1.5vmin;\r\n      }\r\n      &:hover {\r\n        background: rgb(var(--color-primary));\r\n        color: rgb(var(--bg-primary));\r\n      }\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
